import React from 'react';
import LabelWithSiblings from './label-with-siblings';

/**
 * Creates a checkbox input which has beside a label which has the "for" attribute set.
 * NOTE: the id of the checkbox gets overwritten!
 * @param labelContent
 * @param labelClassNames
 * @param checkboxProps
 * @return {JSX.Element}
 * @constructor
 */
function LabelWithCheckbox({ labelContent, labelClassNames, ...checkboxProps }) {
    return (
        <LabelWithSiblings
            siblingsMask="CL"
            labelContent={labelContent}
            labelClassNames={labelClassNames}
            {...checkboxProps}
        />
    );
}

export default LabelWithCheckbox;
